/**
 * Alpinejs
 */

import 'alpinejs/dist/alpine-ie11';

/**
 * Force undetected polyfills.
 * Since useBuiltIns: 'usage' does not currently work with include: ['es7.array.includes', ...]
 */

Promise;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

/**
 * what-input Foundation dependency
 */

require('what-input');

/**
 * Foundation framework core and modules
 *
 * Note: We are using "dist" because Laravel.mix Uglify conf has problems with ES6 backticks '`'
 */

// TODO See https://github.com/foundation/foundation-zurb-template for ideas how to init foundation better
require('foundation-sites/dist/js/plugins/foundation.core.js');
require('foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js');
require('foundation-sites/dist/js/plugins/foundation.util.triggers.js');
require('foundation-sites/dist/js/plugins/foundation.util.keyboard.js');
require('foundation-sites/dist/js/plugins/foundation.util.box.js');
require('foundation-sites/dist/js/plugins/foundation.util.nest.js');
require('foundation-sites/dist/js/plugins/foundation.util.motion.js');
require('foundation-sites/dist/js/plugins/foundation.util.timer.js');
require('foundation-sites/dist/js/plugins/foundation.util.imageLoader.js');

require('foundation-sites/dist/js/plugins/foundation.dropdownMenu.js');
require('foundation-sites/dist/js/plugins/foundation.offcanvas.js');
require('foundation-sites/dist/js/plugins/foundation.tabs.js');
require('foundation-sites/dist/js/plugins/foundation.accordion.js');
require('foundation-sites/dist/js/plugins/foundation.reveal.js');

/**
 * Vue.js
 */

window.Vue = require('vue');

